import React, { useState } from 'react';
import { Box, Button, HStack, Select, Text, SimpleGrid, AlertIcon, Alert, useDisclosure } from '@chakra-ui/react';
import Card from 'components/card';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { currencyFormat } from 'utils/Funciones';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import { FaAngleLeft, FaAngleRight, FaPlus } from 'react-icons/fa6';
import { MdTouchApp } from 'react-icons/md';
import Loader from 'components/loader/Loader';
import InputField from 'components/fields/InputField';
import Modal from 'components/modal/Modal';
import ButtonPrimary from 'components/button/ButtonPrimary';
import { message } from 'utils/Funciones';
import PriceTag from 'components/pricetag';
import { useSelector } from 'react-redux';

function TablePaginationPob({ currentPage, totalPages, onPageChange, pageSize, onPageSizeChange, data, handleAgregarAlCarrito, loading }) {
    const {
        isMutation, userCartB, numOfCartItemsB
    } = useSelector((state) => state.cartReducer);

    const addToCart = useDisclosure()
    const [state, setState] = useState({
        product: null,
        quantity: Number,
        price_unit: Number
    })

    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const gotoPage = (val) => {
        onPageChange(val);
    }

    const openAddToCart = (product) => {
        setState({ ...state, product: product })
        addToCart.onOpen()
    }

    const onSubmitAddToCart = (e) => {
        e.preventDefault();

        if (state.quantity <= 0 || state.price_unit <= 0) {
            message("La cantidad y el precio deben ser mayores que cero.", "error", 3);
            return;
        }

        handleAgregarAlCarrito(state);

        setState({
            ...state,
            product: null,
            quantity: Number,
            price_unit: Number,
        });

        addToCart.onClose();
    };

    return (
        <div>
            {/** DETALLES */}
            <Modal isOpen={addToCart.isOpen} onClose={addToCart.onClose} headerTitle='Reabastecer producto'>
                <div className="px-[5px] md:px-[10px] pt-[20px] pb-[20px] max-w-[1368px] flex flex-col !z-[1004]">
                    <div className="w-full p-4 rounded-2xl bg-white dark:!bg-navy-900 shadow-lg">
                        {/* Título */}
                        <h2 className="text-xl font-semibold text-gray-800 dark:text-white mb-4">
                            Información del producto
                        </h2>

                        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4">
                            {/* Imagen del producto */}
                            <div className="flex-shrink-0">
                                <LazyLoadImage
                                    className="object-cover w-24 h-24 rounded-xl shadow-md"
                                    alt="No image"
                                    effect="black-and-white"
                                    src={`/images/productos/${state?.product?.imagen}`}
                                />
                            </div>

                            {/* Detalles del producto */}
                            <div className="text-center sm:text-left">
                                <p className="text-lg font-medium text-gray-900 dark:text-gray-100">
                                    {state?.product?.name || 'Nombre del producto'}
                                </p>
                                <p className="text-sm text-gray-700 dark:text-gray-400 mt-1">
                                    Stock actual: {state?.product?.stock ?? '0'}
                                </p>
                                <p className="text-sm text-gray-700 dark:text-gray-400">
                                    Precio compra: {state?.product?.preciocompra ? `${currencyFormat(state?.product?.preciocompra)}` : 'No disponible'}
                                </p>
                            </div>
                        </div>
                    </div>
                    <form className="w-full mt-3" onSubmit={onSubmitAddToCart}>
                        <div className="flex flex-wrap">
                            <InputField
                                required={true}
                                autoFocus={true}
                                variant="input"
                                extra="w-full md:w-3/12 mb-3 p-2"
                                label="Cantidad"
                                placeholder="Cantidad"
                                id="quantity"
                                min={0}
                                max={100000}
                                type="number"
                                name="quantity"
                                onChange={(e) => setState({ ...state, quantity: e.target.value })}
                                value={state.quantity}
                            />
                            <InputField
                                required={true}
                                variant="input"
                                extra="w-full md:w-3/12 mb-3 p-2"
                                label="Precio unitario"
                                placeholder="Precio unitario"
                                id="price_unit"
                                min={0}
                                max={100000}
                                type="number"
                                name="price_unit"
                                onChange={(e) => setState({ ...state, price_unit: e.target.value })}
                                value={state.price_unit}
                            />

                            <ButtonPrimary icon={<FaPlus size={28} />}>
                                Agregar
                            </ButtonPrimary>
                        </div>
                    </form>
                </div>
            </Modal>
            <SimpleGrid className="relative" columns={{ base: 2, md: 3, lg: 4 }} spacing={{ base: 2, md: 3, lg: 4 }}>
                {data.length > 0 ? (
                    data.filter((prod) => prod.tipo === 'producto')
                        .map((item, index) => {

                            const cantidadEnCarrito = userCartB?.cart?.cartItems?.length ? userCartB?.cart?.cartItems?.filter(itemcart => itemcart?.product?._id?.toString() === item?._id?.toString())
                                .reduce((acc, itemcartReduce) => acc + itemcartReduce.quantity, 0) : 0

                            const stock = item.stock + cantidadEnCarrito

                            const isDisabled = item.disabled || stock === 0;
                            const isLowStock = stock <= 3 && stock > 0;

                            const cardBg = isDisabled
                                ? 'bg-gradient-to-r from-[rgba(248,113,113,0.6)] to-[rgba(220,38,38,0.6)] dark:from-[rgba(248,113,113,0.6)] dark:to-[rgba(185,28,28,0.6)]'
                                : isLowStock
                                    ? 'bg-gradient-to-r from-[rgba(251,191,36,0.6)] to-[rgba(245,158,11,0.6)] dark:from-[rgba(253,224,71,0.6)] dark:to-[rgba(202,138,4,0.6)]'
                                    : 'bg-white dark:bg-navy-900';

                            return (
                                <Card
                                    key={index}
                                    onClick={() => openAddToCart(item)}
                                    extra={`
    relative cursor-pointer p-3 pb-5 
    bg-white dark:!bg-navy-800 bg-clip-border 
    !shadow-xl shadow-neutral-500 dark:!shadow-navy-950 
    ${cardBg}
  `}
                                >

                                    {/* Icon overlay */}
                                    <div className="absolute top-2 left-2 rounded-full p-2 bg-brand-400 dark:bg-brand-500 opacity-20">
                                        <MdTouchApp size={40} className="text-white" />
                                    </div>

                                    {/* Imagen de producto con fondo difuminado */}
                                    <div className="relative w-full flex items-center justify-center my-2">

                                        {/* Imagen principal en primer plano */}
                                        <div className="relative z-10">
                                            <LazyLoadImage
                                                className="object-cover w-[96px] h-[96px] rounded-lg"
                                                alt="No image"
                                                effect="black-and-white"
                                                src={`/images/productos/${item.imagen}`}
                                            />
                                        </div>
                                    </div>

                                    {/* Product Name */}
                                    <div className="font-normal text-center mt-2 truncate">
                                        {item.name}
                                    </div>

                                    {/* Badge */}
                                    <PriceTag price={item.preciocompra} tipo={item.tipo} stock={stock} />
                                </Card>
                            );
                        })
                ) : (
                    <div className="m-auto col-span-full">
                        <Alert status="error">
                            <AlertIcon />
                            No se encontraron datos
                        </Alert>
                    </div>
                )}

                {loading && <Loader color="#64707d" className="more_loader col-span-full" />}
            </SimpleGrid>
            <HStack spacing={4} mt={4}>
                <div className="mt-2 flex items-center">
                    <button
                        className={`${currentPage === 1 && '!bg-gray-100 dark:!bg-white/5 dark:!text-[rgba(255,255,255,0.15)]'} btn btn-xs bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200 flex items-center justify-center rounded-full p-2 text-3xl text-white transition duration-200 hover:cursor-pointer dark:text-white`}
                        onClick={() => gotoPage(1)}
                        disabled={currentPage === 1}
                    >
                        <FaAngleDoubleLeft size={16} />
                    </button>{" "}
                    <button
                        className={`${currentPage === 1 && '!bg-gray-100 dark:!bg-white/5 dark:!text-[rgba(255,255,255,0.15)]'} ml-2 btn btn-xs bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200 flex items-center justify-center rounded-full p-2 text-3xl text-white transition duration-200 hover:cursor-pointer dark:text-white`}
                        onClick={() => handlePrevious()}
                        disabled={currentPage === 1}
                    >
                        <FaAngleLeft size={16} />
                    </button>{" "}
                    <button
                        className={`${((data.length === 0) || currentPage === totalPages) && '!bg-gray-100 dark:!bg-white/5 dark:!text-[rgba(255,255,255,0.15)]'} ml-2 btn btn-xs bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200 flex items-center justify-center rounded-full p-2 text-3xl text-white transition duration-200 hover:cursor-pointer dark:text-white`}
                        onClick={() => handleNext()}
                        disabled={((data.length === 0) || currentPage === totalPages)}
                    >
                        <FaAngleRight size={16} />
                    </button>{" "}
                    <button
                        className={`${((data.length === 0) || currentPage === totalPages) && '!bg-gray-100 dark:!bg-white/5 dark:!text-[rgba(255,255,255,0.15)]'} ml-2 btn btn-xs bg-brand-500 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:bg-brand-200 flex items-center justify-center rounded-full p-2 text-3xl text-white transition duration-200 hover:cursor-pointer dark:text-white`}
                        onClick={() => gotoPage(totalPages)}
                        disabled={((data.length === 0) || currentPage === totalPages)}
                    >
                        <FaAngleDoubleRight size={16} />
                    </button>{" "}
                </div>
            </HStack>
        </div >

    );
}

export default TablePaginationPob;